
import { Observable } from "rxjs";
import { Weekday } from "../domain/models/week-days";

export abstract class WeekdayRepository {
    abstract getWeekdays(): Observable<Weekday[]>; 
  }